import { render } from "./CaseClusterItemRow.vue?vue&type=template&id=20b096d6&ts=true"
import script from "./CaseClusterItemRow.vue?vue&type=script&lang=ts"
export * from "./CaseClusterItemRow.vue?vue&type=script&lang=ts"

import "./CaseClusterItemRow.vue?vue&type=style&index=0&id=20b096d6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__